import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { WorkerEndReason } from '../../workers/_types/worker-end-reason';
import { WorkersEndReasonsService } from '../../workers/_services/workers-end-reasons.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LoginService } from '../../login/login.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-worker-end-reasons-detail',
    templateUrl: './worker-end-reasons-detail.component.html',
    styleUrls: ['./worker-end-reasons-detail.component.scss'],
    standalone: false
})
export class WorkerEndReasonsDetailComponent {
  public workerEndReasonFormGroup!: RxFormGroup;
  public workerEndReason: WorkerEndReason = new WorkerEndReason();
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private workersEndReasonsService: WorkersEndReasonsService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService
  ) {

    this.workerEndReasonFormGroup = this.formBuilder.formGroup<WorkerEndReason>(this.workerEndReason) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle('Detalle de razón de baja de operario');
    this.topbarService.addBreadcrumb('Razones de baja de operario', '/workerEndReasons');
    let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadWorkerEndReason(id);
    }
    this.allowWrite = this.loginService.hasPermission("WORKERS_END_REASONS.WRITE");
    this.allowDelete = this.loginService.hasPermission("WORKERS_END_REASONS.DELETE");
  }

  async loadWorkerEndReason(id: string) {
    this.workerEndReason = await firstValueFrom(this.workersEndReasonsService.get(id));
    this.workerEndReasonFormGroup.patchValue(this.workerEndReason);
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.workerEndReasonFormGroup);
    if (valid) {
      this.workerEndReason = Object.assign(this.workerEndReason, this.workerEndReasonFormGroup.value);
      await firstValueFrom(this.workersEndReasonsService.save(this.workerEndReason));
      this.messageService.add({ closable: true, severity: 'success', summary: 'Razón de baja guardada correctamente.' });
      this.router.navigate(['workerEndReasons']);
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: 'Error', detail: 'Existen errores, por favor revise el formulario de datos.' });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: '¿Está seguro que desea eliminar la razón de baja?',
      header: 'Eliminar razón de baja',
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar',
      acceptButtonStyleClass: 'p-button-danger',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workersEndReasonsService.delete(this.workerEndReason.id).subscribe({
          next: () => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: 'Razón de baja eliminada correctamente.' });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['workerEndReasons']);
  }

}
